import { ArrowLeftOutlined, ArrowRightOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Checkbox,
  Form,
  Image,
  Input,
  InputNumber,
  message,
  Select,
  Spin,
  Modal
} from 'antd';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { loadStripe } from '@stripe/stripe-js';
import PropTypes from 'prop-types';
import * as _ from 'lodash';

import { setStepCount, setPersonalDetails, setStorageStepCount, setCustomer } from '../../store/actionCreators';
import { createCustomer, getHdyfu, updateCustomer, getCustomerByEmail } from '../../../../data/API';
import { storageStripeCheckoutSession, placeStorageOrder } from '../../../../data/API';
import { getMyData, setToken, setMyData } from '../../../../utils/token';
import useGetPrice from '../../../../hooks/useGetPrice';
import TermsServiceModal from './TermsService';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PAYMENT_KEY);

const PersonalDetails = ({
  tabref,
  isParentNextStepClicked,
  setParentNextStepClicked,
  stepRef,
  extraWork,
  customerInfo
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isForFuture, setIsForFuture] = useState(false);
  const { order, customerr } = useSelector((state) => state.storage);
  const [showValidation, setShowValidation] = useState(false);
  const { boxPrices } = useGetPrice();
  const currentStep = useSelector((state) => state.storage.currentStorageStep);
  const { personalDetails } = useSelector((state) => state.storage.order);
  const userInfo = getMyData();
  const customer = JSON.parse(localStorage.getItem('authData'));
  const setOrder = (payload) => dispatch({ type: 'SET_ORDER', payload });
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showCnfPassword, setShowCnfPassword] = useState(false);
  const userIsLoggedIn = !!userInfo;
  const [hearingSources, setHearingSources] = useState([]);
  const [isDeliveryDetailsLoaded, setIsDeliveryDetailsLoaded] = useState(false);
  const [isTermsModalVisible, setIsTermsModalVisible] = useState(false);
  const [hasAgreedInModal, setHasAgreedInModal] = useState(false);
  const [emailCheckLoading, setEmailCheckLoading] = useState(false);
  const [emailExists, setEmailExists] = useState(false);
  const [isRentalUserInStorage, setIsRentalUserInStorage] = useState(false);
  const [rentalUserStorageCheck, setRentalUserStorageCheck] = useState(null);

  // Helper function to get user type from token
  const getUserTypeFromToken = () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        return null;
      }
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.type;
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  };

  useEffect(() => {
    if (userInfo && Object.keys(personalDetails).length == 0) {
      const formData = {
        name: userInfo?.name,
        email: userInfo?.email
      };
      
      // Check if navigating from Quick Actions and add mobile numbers
      const urlParams = new URLSearchParams(window.location.search);
      const fromQuickActions = urlParams.get('from') === 'quick-actions';
      if (fromQuickActions) {
        const mobile = urlParams.get('mobile');
        const secondaryMobile = urlParams.get('secondary_mobile');
        if (mobile) formData.mobile = mobile;
        if (secondaryMobile) formData.secondary_mobile = secondaryMobile;
      }
      
      form.setFieldsValue(formData);
    }
  }, []);

  // Check if logged-in rental user exists as storage customer
  useEffect(() => {
    const checkRentalUserInStorage = async () => {
      if (!userIsLoggedIn || !userInfo?.email) return;
      
      const userType = getUserTypeFromToken();
      if (userType !== 'rental_customer') return;

      console.log('Rental user detected, checking if exists in storage system:', userInfo.email);
      
      try {
        const response = await getCustomerByEmail(userInfo.email);
        console.log('Storage customer check response:', response);
        
        if (response?.data?.success && response?.data?.data) {
          // Rental user exists as storage customer - treat as normal logged-in flow
          console.log('Rental user found in storage system');
          setIsRentalUserInStorage(false);
          setRentalUserStorageCheck('exists');
          
          const storageCustomerData = response.data.data;
          if (storageCustomerData.mobile || storageCustomerData.secondary_mobile) {
            const formData = {};
            if (storageCustomerData.mobile) {
              formData.mobile = formatPhoneNumber(storageCustomerData.mobile);
            }
            if (storageCustomerData.secondary_mobile) {
              formData.secondary_mobile = formatPhoneNumber(storageCustomerData.secondary_mobile);
            }
            console.log('Populating form with existing storage customer data:', formData);
            form.setFieldsValue(formData);
            dispatch(setPersonalDetails({ ...personalDetails, ...formData }));
          }
        } else {
          // Rental user does NOT exist as storage customer - treat as new user
          console.log('Rental user NOT found in storage system - treating as new user');
          setIsRentalUserInStorage(true);
          setRentalUserStorageCheck('not_exists');
        }
      } catch (error) {
        console.log('Error checking rental user in storage:', error);
        // If API fails, assume user doesn't exist in storage (safer approach)
        setIsRentalUserInStorage(true);
        setRentalUserStorageCheck('error_assume_new');
      }
    };

    checkRentalUserInStorage();
  }, [userIsLoggedIn, userInfo?.email]);

 useEffect ( () => {
  getHearingSources();
 }, [])

 const getHearingSources = async () => {
     const response = await getHdyfu();
 
     if (response?.data?.results) {
       setHearingSources(response?.data?.results);
     } else {
       return message.error('error while fetching hearing sources');
     }
   };

 useEffect(() => {
  const storedState = localStorage.getItem('storageState');
  if (storedState) {
    const parsedState = JSON.parse(storedState);
    
    if (parsedState.order?.personalDetails) {
      const personalData = parsedState.order.personalDetails;

      form.setFieldsValue({
        name: personalData.name,
        email: personalData.email,
        mobile: personalData.mobile,
        secondary_mobile: personalData.secondary_mobile
      });

      setPersonalDetails(personalData.name, personalData.email, personalData.mobile, personalData.secondary_mobile);
      dispatch(setPersonalDetails(personalData));
    }
  }
}, []);

// Save state to localStorage whenever relevant state changes
useEffect(() => {
  if (order) {
    const stateToStore = {
      currentStep,
      order: {
        boxCount: order.boxCount,
        deliveryDetails: order.deliveryDetails || {},
        paymentDetails: order.paymentDetails || {},
        personalDetails: order.personalDetails || {}
      }
    };
    localStorage.setItem('storageState', JSON.stringify(stateToStore));
  }
}, [currentStep, order]);

useEffect(() => {
  if (userInfo && (!personalDetails || Object.keys(personalDetails).length === 0)) {
    const initialValues = {
      name: userInfo?.name,
      email: userInfo?.email
    };

    const urlParams = new URLSearchParams(window.location.search);
    const fromQuickActions = urlParams.get('from') === 'quick-actions';
    const mobile = urlParams.get('mobile');
    const secondaryMobile = urlParams.get('secondary_mobile');
    const userType = getUserTypeFromToken();
    
    if (fromQuickActions || (mobile && userType === 'rental_customer') || (!userInfo && mobile)) {
      if (mobile) initialValues.mobile = mobile;
      if (secondaryMobile) initialValues.secondary_mobile = secondaryMobile;
    } else {

      if (userType === 'rental_customer' && userInfo || userType === 'customer' && userInfo || userType === 'both_customer' && userInfo) {
        console.log('Populating rental user data:', userInfo);
        if (userInfo.mobile) {
          initialValues.mobile = formatPhoneNumber(userInfo.mobile);
        }
        if (userInfo.secondary_mobile) {
          initialValues.secondary_mobile = formatPhoneNumber(userInfo.secondary_mobile);
        }
      }
    }
    
    console.log('Setting initial values for user:', initialValues);
    form.setFieldsValue(initialValues);
    dispatch(setPersonalDetails(initialValues));
  }
}, [userInfo]);

useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const mobile = urlParams.get('mobile');
  const secondaryMobile = urlParams.get('secondary_mobile');
  
  console.log('Query param check:', { mobile, secondaryMobile });
  
  if (mobile || secondaryMobile) {
    console.log('Found mobile in query params, setting form values');
    const values = {};
    if (mobile) values.mobile = mobile;
    if (secondaryMobile) values.secondary_mobile = secondaryMobile;
    
    // Force set form values even if they were set before
    setTimeout(() => {
      form.setFieldsValue(values);
      dispatch(setPersonalDetails({ ...personalDetails, ...values }));
    }, 100);
  }
}, [form]); // Added form dependency to ensure it runs when form is ready 

useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const paymentStatus = urlParams.get('payment_status');
  
  if (paymentStatus === 'success') {
    // Clear storage state
    localStorage.removeItem('storageState');
  }
}, []);

useEffect(() => {
  console.log('CustomerInfo useEffect triggered:', customerInfo);
    if (customerInfo?.custormerData) {
      const formData = {};
      
      if (customerInfo.custormerData.mobile) {
        formData.mobile = formatPhoneNumber(customerInfo.custormerData.mobile);
      }
      if (customerInfo.custormerData.secondary_mobile) {
        formData.secondary_mobile = formatPhoneNumber(customerInfo.custormerData.secondary_mobile);
      }
      
      if (customerInfo.custormerData.name) {
        formData.name = customerInfo.custormerData.name;
      }
      if (customerInfo.custormerData.email) {
        formData.email = customerInfo.custormerData.email;
      }
      
      console.log('Setting form data from customerInfo:', formData);
      if (Object.keys(formData).length > 0) {
        form.setFieldsValue(formData);
        dispatch(setPersonalDetails({ ...personalDetails, ...formData }));
      }
    }
  }, [customerInfo]);



  useEffect(() => {
    window.scrollTo({
      top: tabref?.current.offsetTop - 100,
      behavior: 'smooth'
    });
  }, []);

  useEffect(() => {
    if (personalDetails) {
      form.setFieldsValue({
        name: userInfo ? userInfo?.name : personalDetails?.name ? personalDetails?.name : '',
        email: userInfo ? userInfo?.email : personalDetails?.email ? personalDetails?.email : '',
        mobile: personalDetails?.mobile ? formatPhoneNumber(personalDetails?.mobile) : '',
        secondary_mobile: personalDetails?.secondary_mobile
          ? formatPhoneNumber(personalDetails?.secondary_mobile)
          : '',
        coupon: personalDetails?.coupon ? personalDetails?.coupon : '',
        isForFuture: personalDetails?.isForFuture ? personalDetails?.isForFuture : false
      });
    }
  }, [personalDetails]);

  useEffect(() => {
    if (customerInfo) {
      form.setFieldsValue({
        mobile: formatPhoneNumber(customerInfo?.custormerData?.mobile),
        secondary_mobile: formatPhoneNumber(customerInfo?.custormerData?.secondary_mobile)
      });
    }
  }, [customerInfo]);

  const checkEmailExists = async (email) => {
    if (!email) return false;
    // Skip email check if user is logged in AND exists in storage (normal storage user)
    if (userIsLoggedIn && !isRentalUserInStorage) return false;
    
    try {
      setEmailCheckLoading(true);
      
      console.log('Checking email exists for:', email);
      const response = await createCustomer({ email: email });
      console.log('Email check response:', response);
      
      // Check for exists property in response data
      if (response?.data?.exists !== undefined) {
        console.log('Email exists (from data.exists):', response.data.exists);
        return response.data.exists;
      }
      
      // Check for exists property in nested data
      if (response?.data?.data?.exists !== undefined) {
        console.log('Email exists (from data.data.exists):', response.data.data.exists);
        return response.data.data.exists;
      }
      
      // If successful response but no exists property, email doesn't exist
      console.log('Email check successful - email does not exist');
      return false;
    } catch (error) {
      console.log('Email check error:', error);
      const errorMessage = error?.response?.data?.message || error?.message || '';
      
      // Check for duplicate email error patterns
      if (errorMessage.toLowerCase().includes('duplicate') || 
          errorMessage.toLowerCase().includes('already exists') || 
          errorMessage.toLowerCase().includes('unique constraint') ||
          (errorMessage.toLowerCase().includes('email') && errorMessage.toLowerCase().includes('exist'))) {
        console.log('Email exists based on error message');
        return true;
      }
      
      console.log('Email check failed - assuming email does not exist');
      return false;
    } finally {
      setEmailCheckLoading(false);
    }
  };

  const handleEmailBlur = async (e) => {
    const email = e.target.value;
    // Check email for non-logged users OR rental users who don't exist in storage
    if (email && (!userIsLoggedIn || isRentalUserInStorage) && email.includes('@')) {
      console.log('Email blur triggered for:', email);
      const exists = await checkEmailExists(email);
      console.log('Setting emailExists to:', exists);
      setEmailExists(exists);
      form.setFields([{
        name: 'email',
        errors: []
      }]);
    }
  };

  const nextStep = () => {
    dispatch(setStorageStepCount(currentStep + 1));
    sessionStorage.setItem('orderType', 'storage');
  };

  const prevStep = () => {
    dispatch(setStorageStepCount(currentStep - 1));
  };

  useEffect(() => {
    if (isParentNextStepClicked && stepRef == 3) {
      setParentNextStepClicked(false);
      setTimeout(
        function () {
          onSubmit();
        }.bind(this),
        0
      );
    }
  }, [isParentNextStepClicked]);

  const onSubmit = async () => {
    sessionStorage.setItem('orderType', 'storage')
    try {

      if (!order.deliveryDetails || Object.keys(order.deliveryDetails).length === 0) {
        message.error('Delivery details are missing. Please go back and complete Step 2.');
        setIsFormSubmitted(false);
        return;
      }
      
       let formValues = await form.validateFields();

       if (formValues?.mobile) {
         formValues.mobile = formValues.mobile.replace(/[()-\s]/g, '');
       }
       if (formValues?.secondary_mobile) {
         formValues.secondary_mobile = formValues.secondary_mobile.replace(/[()-\s]/g, '');
       }
       setIsFormSubmitted(true);
       
       const shouldTreatAsNewUser = !userIsLoggedIn || isRentalUserInStorage;
       const isNewUser = shouldTreatAsNewUser && !emailExists;

       if (shouldTreatAsNewUser) {
         const customerData = {
           name: formValues.name,
           email: formValues.email,
           mobile: formValues.mobile,
           secondary_mobile: formValues.secondary_mobile
         };

         if (isNewUser) {
           if (!agreeTerms) {
             message.error('Please agree to BlueBox Terms of Service');
             setIsFormSubmitted(false);
             return;
           }

           customerData.password = formValues.password;
           customerData.hdyfu_id = formValues.hdyfu_id;
           customerData.agreedTerms = true;
         }

         console.log('Attempting to create/update customer:', customerData);

         try {
           const customerResponse = await createCustomer(customerData);
           console.log('Customer response:', customerResponse);

           if (!customerResponse?.data?.success) {
             throw new Error('Failed to process customer');
           }
         } catch (error) {
           console.log('Customer processing error:', error);
           setIsFormSubmitted(false);

           const errorMessage = error?.response?.data?.message || error?.message || 'Failed to process customer';
           message.error(errorMessage);

           throw new Error(errorMessage);
         }
       }
       
       const updatedOrder = {
         ...order,
         personalDetails: formValues
       };
       dispatch(setOrder(updatedOrder));
       
       const orderObj = {
         boxCount: order.boxCount,
         // For rental users creating storage accounts, don't pass customer_id as it's from rental system
         customer_id: (userInfo && !isRentalUserInStorage) ? userInfo.id : undefined,
         deliveryDetails: order.deliveryDetails || {},
         personalDetails: formValues,
         email: formValues.email,
         name: formValues.name,
         mobile: formValues.mobile,
         secondary_mobile: formValues.secondary_mobile,
         total_amount: calculateTotalAmount(),
         boxes_amount: order.boxCount * Number(boxPrices[0]?.price) * 3,
         order_date: new Date(),
         password: formValues.password,
         cnfPassword: formValues.cnfPassword
       };
       

       const completeState = {
         currentStep,
         order: updatedOrder
       };
       localStorage.setItem('storageState', JSON.stringify(completeState));
       
       let orderResponse = await placeStorageOrder(orderObj);

       console.log('Full orderResponse:', orderResponse);
       console.log('orderResponse.data:', orderResponse?.data);
       console.log('orderResponse.data.data:', orderResponse?.data?.data);

       if (orderResponse?.data?.success && orderResponse?.data?.data?.order?.id) {
         let sessionPayload = {
           order_id: orderResponse.data.data.order.id,
           order_type: "storage",
           amount: orderObj.total_amount,
           discount: 0,
           payment: {
             billing_details: {
               email: formValues.email
             }
           }
         };

         console.log('Creating checkout session with payload:', sessionPayload);

         let sessionRes = await storageStripeCheckoutSession(sessionPayload);
         if (sessionRes?.data?.success) {
           const stripe = await stripePromise;
           const result = await stripe.redirectToCheckout({
             sessionId: sessionRes.data.data.session
           });
           setIsFormSubmitted(false);
         } else {
           message.error('Unable to place order, Please try again...!');
           setIsFormSubmitted(false);
         }
       } else {
         console.error('Order creation failed or invalid response structure:', orderResponse?.data);
         message.error('Unable to place order, Please try again...!');
         setIsFormSubmitted(false);
       }
     } catch (error) {
       message.error(error.message || 'Unable to process order. Please try again.');
       setIsFormSubmitted(false);
     }
   };
  
 
   const changeAgreeTerms = (e) => {
    if (!hasAgreedInModal) {
      e.preventDefault();
      setIsTermsModalVisible(true);
      return;
    }
    
    setAgreeTerms(e.target.checked);
    form.setFieldsValue({
      termsAndCondition: e.target.checked
    });
  };

  const handleTermsAgreement = (agreed) => {
    setHasAgreedInModal(agreed);
    setAgreeTerms(agreed);
    form.setFieldsValue({
      termsAndCondition: agreed
    });
  };

  const showTermsModal = () => {
    setIsTermsModalVisible(true);
  };

  const handleTermsModalClose = () => {
    setIsTermsModalVisible(false);
  };

  // Handle terms acceptance from modal
  const handleTermsAccept = (accepted) => {
    if (accepted) {
      setHasAgreedInModal(true);
      setAgreeTerms(true);
      form.setFieldsValue({
        termsAndCondition: true
      });
    }
  };

  const calculateTotalAmount = () => {
    let extraCost = 0;
    if (order?.deliveryDetails?.extra_work_id) {
      const extraWorkObj = extraWork?.find(work => work.id === order.deliveryDetails.extra_work_id);
      if (extraWorkObj) {
        extraCost = Number(extraWorkObj.price);
      }
    }
    
    // Default to a base price if boxPrices[0] is undefined
    const basePrice = boxPrices[0]?.price || 0;
    return order.boxCount * Number(basePrice) * 3 + extraCost;
  };

  const validateMobileNumber = (e) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  };

  const formatPhoneNumber = (value) => {
    if (!value) return value;

    const phoneNum = value.replace(/[^\d]/g, '');
    const phoneLen = phoneNum.length;

    if (phoneLen < 4) return phoneNum;

    if (phoneLen < 7) {
      return `(${phoneNum.slice(0, 3)}) ${phoneNum.slice(3)}`;
    }

    return `(${phoneNum.slice(0, 3)}) ${phoneNum.slice(3, 6)}-${phoneNum.slice(6, 10)}`;
  };

  const handlePrimary = (e) => {
    const formattedPhone = formatPhoneNumber(e.target.value);
    form.setFieldsValue({
      mobile: formattedPhone
    });
    handlePersonalDetailsRedux('mobile', formattedPhone);
  };

  const handleSecondary = (e) => {
    const formattedPhone = formatPhoneNumber(e.target.value);
    form.setFieldsValue({
      secondary_mobile: formattedPhone
    });
    handlePersonalDetailsRedux('secondary_mobile', formattedPhone);
  };

  const handlePersonalDetailsRedux = (type, e) => {
    switch (type) {
      case 'name':
        form.setFieldsValue({
          name: e.target.value
        });
        break;
      case 'email':
        form.setFieldsValue({
          email: e.target.value
        });
        break;
      case 'mobile':
        form.setFieldsValue({
          mobile: e
        });
        break;
      case 'secondary_mobile':
        form.setFieldsValue({
          secondary_mobile: e
        });
        break;
      case 'coupon':
        form.setFieldsValue({
          coupon: e.target.value
        });
        break;
      case 'isForFuture':
        form.setFieldsValue({
          isForFuture: e.target.checked
        });
        break;
      case 'password':
        form.setFieldsValue({
          password: e.target.value
        });
        break;
      case 'cnfPassword':
        form.setFieldsValue({
          cnfPassword: e.target.value
        });
        break;
    }

    dispatch(setPersonalDetails(form.getFieldsValue()));
  };

  return (
    <div>
      <div className="steps bg-white" id="steps">
        <h2 className="shopping-cart-header text-white text-center py-2 fs-20 steps-title">
          Step 3: Personal Details
        </h2>
        <Card bordered={false} className="w-100 px-3 pt-3 pb-4">
          <Spin spinning={isFormSubmitted} tip="processing...">
            <Form
              form={form}
              layout="vertical"
              autoComplete="off"
              initialValues={{
                isForFuture: personalDetails?.isForFuture ? personalDetails?.isForFuture : false
              }}
              style={{ position: 'relative', zIndex: 0 }}>
              <Row>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    name="name"
                    label="Name"
                    rules={[{ required: true, message: 'Please enter the name' }]}>
                    <Input
                      size={'large'}
                      type="text"
                      placeholder=""
                      className="signup-form-input"
                      readOnly={userIsLoggedIn && !isRentalUserInStorage}
                      style={userIsLoggedIn && !isRentalUserInStorage ? { backgroundColor: '#f5f5f5', cursor: 'default' } : {}}
                      onChange={(e) => handlePersonalDetailsRedux('name', e)}
                    />
                  </Form.Item>
                </Col>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    name="email"
                    label="Email"
                    validateTrigger="onBlur"
                    rules={[
                      { required: true, message: 'Please input the email address' },
                      { type: 'email', message: 'Please enter a valid email address' }
                    ]}
                    validateStatus={emailCheckLoading ? 'validating' : ''}
                    help={emailCheckLoading ? 'Checking email availability...' : ''}
                  >
                    <Input
                      size={'large'}
                      type="text"
                      placeholder=""
                      className="signup-form-input"
                      readOnly={userIsLoggedIn && !isRentalUserInStorage}
                      style={userIsLoggedIn && !isRentalUserInStorage ? { backgroundColor: '#f5f5f5', cursor: 'default' } : {}}
                      onChange={(e) => {
                        setShowValidation(true);
                        let el = document.getElementById('email_help');
                        if (el) {
                          el.classList.add('d-none');
                        }
                        handlePersonalDetailsRedux('email', e);
                        
                        if ((!userIsLoggedIn || isRentalUserInStorage) && emailExists) {
                          setEmailExists(false);
                          form.setFields([{
                            name: 'email',
                            errors: []
                          }]);
                        }
                      }}
                      onBlur={(e) => {
                        setShowValidation(false);
                        let el = document.getElementById('email_help');
                        if (el) {
                          el.classList.remove('d-none');
                        }
                        
                        if (!userIsLoggedIn || isRentalUserInStorage) {
                          handleEmailBlur(e);
                        }
                      }}
                      suffix={emailCheckLoading ? <Spin size="small" /> : null}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {(!userIsLoggedIn || isRentalUserInStorage) && !emailExists && (
                <Row>
                  <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className={'pb-0'}>
                    <div className="position-relative">
                      <Form.Item
                        label="Password"
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter your password!'
                          },
                          {
                            min: 6,
                            message: 'Password must be at least 6 characters long!'
                          }
                        ]}>
                        <Input
                          size={'large'}
                          type={!showPassword ? 'password' : 'text'}
                          className="signup-form-input bluebox-placeholder mb-0"
                          onChange={(e) => handlePersonalDetailsRedux('password', e)}
                        />
                      </Form.Item>
                      <div
                        className="toggle-icon"
                        onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? (
                          <EyeInvisibleOutlined className="ant-eye-icon" />
                        ) : (
                          <EyeOutlined className="ant-eye-icon" />
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className={'pb-0'}>
                    <div className="position-relative">
                      <Form.Item
                        label="Confirm Password"
                        name="cnf_password"
                        dependencies={['password']}
                        rules={[
                          {
                            required: true,
                            message: 'Please confirm your password!'
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value || getFieldValue('password') === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error('The two passwords that you entered do not match!')
                              );
                            }
                          })
                        ]}>
                        <Input
                          size={'large'}
                          type={!showCnfPassword ? 'password' : 'text'}
                          className="signup-form-input bluebox-placeholder mb-0"
                          onChange={(e) => handlePersonalDetailsRedux('cnfPassword', e)}
                        />
                      </Form.Item>
                      <div
                        className="toggle-icon"
                        onClick={() => setShowCnfPassword(!showCnfPassword)}>
                        {showCnfPassword ? (
                          <EyeInvisibleOutlined className="ant-eye-icon" />
                        ) : (
                          <EyeOutlined className="ant-eye-icon" />
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
              
              <Row>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    name="mobile"
                    label="Mobile Number"
                    validateTrigger="onBlur"
                    rules={[
                      { required: true, message: 'Please input the mobile number', min: 14 }
                    ]}>
                    <Input
                      size={'large'}
                      type="text"
                      placeholder=""
                      className="signup-form-input"
                      minLength={14}
                      maxLength={14}
                      onKeyPress={(event) => {
                        validateMobileNumber(event);
                      }}
                      onChange={(e) => {
                        handlePrimary(e);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    name="secondary_mobile"
                    label="Secondary phone number"
                    validateTrigger="onBlur"
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(rule, value) {
                          if (
                            getFieldValue('secondary_phone_number') &&
                            getFieldValue('secondary_phone_number').length != 14
                          ) {
                            return Promise.reject('Please enter valid number');
                          } else {
                            return Promise.resolve();
                          }
                        }
                      })
                    ]}>
                    <Input
                      size={'large'}
                      type="text"
                      placeholder=""
                      className="signup-form-input"
                      minLength={14}
                      maxLength={14}
                      onKeyPress={(event) => {
                        validateMobileNumber(event);
                      }}
                      onChange={(e) => {
                        handleSecondary(e);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}></Col>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item name="isForFuture" noStyle valuePropName="checked">
                    <Checkbox
                      className="agree-lable"
                      onChange={(e) => {
                        handlePersonalDetailsRedux('isForFuture', e);
                      }}>
                      Save my details for future orders
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>

            {(!userIsLoggedIn || isRentalUserInStorage) && !emailExists && (
              <Row>
                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} className={'pb-0 mt-m5'}>
                  <Form.Item
                    name="hdyfu_id"
                    label="How did you hear about us?"
                    rules={[{ required: true, message: 'Please input how you hear about us?' }]}>
                    <Select size="large">
                      {hearingSources?.map((obj, index) => {
                        return (
                          <Select.Option key={`source_${index}`} value={obj?.id}>
                            {obj.title}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col
                  className="px-3 py-0 text-start"
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={12}
                >
                  <Form.Item
                    className="mb-0"
                    name="termsAndCondition"
                    valuePropName="checked"
                    rules={[
                      { required: true, message: 'Please accept the terms and condition' }
                    ]}
                  >
                    <Checkbox
                      className="fs-15"
                      value={agreeTerms}
                      onChange={(e) => {
                        changeAgreeTerms(e);
                      }}
                    >
                      I agree to <span 
                        onClick={showTermsModal} 
                        className="agree-term" 
                        style={{ cursor: 'pointer', color: '#1890ff', textDecoration: 'underline' }}
                      >
                        Terms and Services
                      </span>
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            )}
            </Form>
          </Spin>
        </Card>
      </div>

      <div className="row mt-4 mb-10">
        <div className="col d-flex justify-content-start align-items-center">
          <Button
            className="btn-previous-step red-border-button"
            icon={<ArrowLeftOutlined />}
            onClick={prevStep}
            size={'large'}>
            Previous Step
          </Button>
        </div>
        <div className="col d-flex justify-content-end align-items-center">
          <Button
            style={{ maxWidth: '250px' }}
            className="btn-next-step red-button"
            icon={<ArrowRightOutlined />}
            onClick={onSubmit}
            loading={isFormSubmitted}
            size={'large'}>
            {!isFormSubmitted ? 'Continue to payment' : 'Redirecting..'}
          </Button>
        </div>
      </div>

      {/* Terms Service Modal */}
      <TermsServiceModal 
      visible={isTermsModalVisible} 
      onClose={handleTermsModalClose} 
      onTermsAccept={handleTermsAccept}
    />
    </div>
  );
};


export default PersonalDetails;

PersonalDetails.propTypes = {
  tabref: PropTypes.any,
  stepRef: PropTypes.any,
  isParentNextStepClicked: PropTypes.any,
  setParentNextStepClicked: PropTypes.any,
  deliveryWindows: PropTypes.any,
  extraWork: PropTypes.any,
  customerInfo: PropTypes.any
};